import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";

const REGION = "eu-north-1";
const BUCKET = "third-bracket";
const ACCESS_KEY_ID = "AKIAWZQHX3YHPYAL6XAP";
const SECRET_ACCESS_KEY = "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";

const s3 = new S3Client({
  region: REGION,
  credentials: {
    accessKeyId: ACCESS_KEY_ID,
    secretAccessKey: SECRET_ACCESS_KEY,
  },
});

export const uploadFileToS3 = async (file) => {
  try {
    const fileName = `${Date.now()}-${file.name}`;
    const key = `uploads/${fileName}`;
    
    const arrayBuffer = await file.arrayBuffer(); // ✅ Convert to ArrayBuffer

    const command = new PutObjectCommand({
      Bucket: BUCKET,
      Key: key,
      Body: arrayBuffer, // ✅ Send arrayBuffer instead of File object
      ContentType: file.type,
      ACL: "public-read",
    });

    await s3.send(command);

    return `https://${BUCKET}.s3.${REGION}.amazonaws.com/${key}`;
  } catch (err) {
    console.error("❌ S3 Upload Error", err);
    throw err;
  }
};
